import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHNivelUpd = async (credentials, data) => {
    const body = {
        service: "RNHNivelUpd",
        params: {
            rnhNivelId: data?.id,
            rnhNivelCod: data?.cod,
            rnhNivelNombre: data?.name,
            rnhTipoComponenteCod: data?.maxLevel,
            rnhNivelVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
